import factory from './factory'

export default {
  hasCountryFilter (state) {
    return state.appliedFilters.hasOwnProperty(factory.countryField)
  },
  hasRegionFilter (state) {
    return state.appliedFilters.hasOwnProperty(factory.regionField)
  },
  hasFilters (state) {
    return Object.keys(state.appliedFilters).length > 0
  }
}
